import axios from 'axios';
import { presignedS3 } from '@goldcast/api/backend';

import { getCloudFrontUrl, RESIZED_USER_IMAGE_S3_FOLDER, RESIZED_MEDIUM_USER_IMAGE_S3_FOLDER } from '@/constants';
import NotificationService from '@/services/dialogs/notifications';
import loggerService from './logger.service';

export function uploadProfileJpeg(key, image, userAuthToken, imageFileName) {
  return new Promise((resolve, reject) => {
    const renamedFile = new File([image], imageFileName, { type: image.type });
    const getPresignedUrlPromise = presignedS3({
      body: {
        key: key,
        file_type: renamedFile.type
      }
    });
    const getBlobPromise = getFileBlob(renamedFile);

    Promise.all([getPresignedUrlPromise, getBlobPromise])
      .then(([signerRes, blob]) => {
        const presignedUrl = signerRes?.signedUrl;
        if (presignedUrl) {
          return axios.put(presignedUrl, blob, {
            headers: { 'Content-Type': renamedFile.type }
          });
        }
      })
      .then(resolve)
      .catch(err => {
        NotificationService.toast('Image upload failed!', err?.data?.reason, 'error', null, 15000);
        reject(err);
      });
  });
}

export function getFileBlob(jpegImage) {
  return new Promise(resolve => {
    let reader = new FileReader();
    reader.onload = function (e) {
      let blob = new Blob([new Uint8Array(e.target.result)], {
        type: jpegImage.type
      });
      resolve(blob);
    };
    reader.readAsArrayBuffer(jpegImage);
  });
}

export function getUserProfileImageUrl(user) {
  if (user) {
    return user.profile_picture_url ? `${getCloudFrontUrl('CLOUDFRONT_URL')}${user.profile_picture_url}` : '';
  }
  return '';
}

export function getMediumSizedImage(user) {
  try {
    if (!user?.profile_picture_url) {
      return '';
    }

    const originalUrlSplit = user.profile_picture_url?.split('/') || [];
    originalUrlSplit.shift();
    const joined = originalUrlSplit.join('/');

    return joined && `${getCloudFrontUrl('CLOUDFRONT_URL')}${RESIZED_MEDIUM_USER_IMAGE_S3_FOLDER}/${joined}`;
  } catch (err) {
    loggerService.error('error in getMediumSizedImage', err);
    return '';
  }
}

export function getPublicThumbnailImage(user) {
  try {
    if (!user?.profile_picture_url) {
      return '';
    }

    const originalUrlSplit = user.profile_picture_url?.split('/') || [];
    originalUrlSplit.shift();
    const joined = originalUrlSplit.join('/');

    return joined && `${getCloudFrontUrl('CLOUDFRONT_URL')}${RESIZED_USER_IMAGE_S3_FOLDER}/${joined}`;
  } catch (err) {
    loggerService.error('error in getPublicThumbnailImage', err);
    return '';
  }
}
